import { styled } from '@mui/material'
import { WappMode } from '@weblite-wapps/protocol'
import ReactLoading from 'react-loading'
import { WappIframe } from '../wapp-iframe'
import { stageIsSatisfyingCondition, WappCondition } from '../../common'
import { wappView } from '../../wapprunner-pool/wapprunnerPool.reducer'
import { removeFromWappPool } from '../../wapprunner-pool/wapprunnerPool.ops'
import { useSelector } from '../../setup/redux'
import { useEffect } from 'react'

const Container = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const LoadingContainer = styled('div')`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  /* @noflip */
  left: 0;
`

const Loading = styled(ReactLoading)(({ theme }) => ({
  fill: `${theme.palette.secondary.main} !important`,
}))

export function Wapprunner({ wappSessionId }: { wappSessionId: string }) {
  useEffect(() => {
    return () => {
      const wapp = wappView(wappSessionId)
      if (!wapp?.mode || wapp?.mode === WappMode.INLINE)
        console.log('UNMOUNT', { wappSessionId })
      removeFromWappPool(wappSessionId)
    }
  }, [wappSessionId])

  const wapp = useSelector(() => wappView(wappSessionId))
  if (!wapp) return null

  if (!stageIsSatisfyingCondition(WappCondition.RUN_WAPP, wapp.stage))
    return null

  const isLoading = stageIsSatisfyingCondition(
    WappCondition.SHOW_LOADING,
    wapp.stage,
  )
  const hideLoading =
    (wapp.mode === WappMode.OVERLAY || wapp.mode === WappMode.MAIN) && isLoading

  return (
    <Container>
      {isLoading && (
        <LoadingContainer
          style={{ visibility: hideLoading ? 'hidden' : 'unset' }}
        >
          <Loading type="bubbles" />
        </LoadingContainer>
      )}

      <WappIframe wapp={wapp} hidden={isLoading} />
    </Container>
  )
}
